import { t } from "@lingui/macro";
import type {
  ExpenseBudgetCategory,
  TopProject,
} from "@src/__generated__/urql-graphql";
import { observer, useLocalObservable } from "mobx-react-lite";
import { useEffect } from "react";
import { Bar, BarChart, ResponsiveContainer, Tooltip, XAxis } from "recharts";
import { TopGraphTooltipContent } from "../../../common/graphs/top-graph-tooltip";
import { TopProjectGraphStore } from "./store";

export type TopProjectsGraphProps = {
  expenseBudgetCategories: Pick<ExpenseBudgetCategory, "id" | "name">[];
  data: TopProject[];
};

export const TopProjectsGraph = observer(function TopProjectsGraph({
  expenseBudgetCategories,
  data,
}: TopProjectsGraphProps) {
  const { store } = useLocalObservable(() => ({
    store: new TopProjectGraphStore(data, expenseBudgetCategories),
  }));

  useEffect(() => {
    store.setData(data);
  }, [data]);

  return (
    <ResponsiveContainer width="100%" height="100%">
      <BarChart data={store.dataForGraph}>
        <XAxis dataKey="total_value_formatted" fontSize="8px" />
        <Tooltip
          content={<TopGraphTooltipContent type="project" />}
          wrapperStyle={{
            zIndex: 1,
          }}
        />
        <Bar
          dataKey="our_work_value"
          name={t`Work`}
          stackId="a"
          fill="#BBCAFF"
        />
        {store.expenseBudgetCategories.map((category, index) => (
          <Bar
            key={`${category.id}-${category.name}`}
            dataKey={category.name}
            stackId="a"
            name={category.name}
            fill={store.colors[index]}
          />
        ))}
      </BarChart>
    </ResponsiveContainer>
  );
});
